/**
 * The program context itself, apart from its provider.
 *
 * In its own file so `Project.tsx` exports only components and hooks (fast
 * refresh), and so the hooks that only KEY by the program - `useChoices`,
 * issue #91 - can read it without `useProject`, which throws outside a
 * provider. Anything else uses `useProject`.
 */

import { createContext } from 'react'
import type { ProjectRow } from '../schema'

export interface ProjectState {
  /** Every program this person has not hidden. */
  projects: ProjectRow[]
  /** The one being shown, or null when none has been resolved. */
  current: ProjectRow | null
  /** The branch its model was read from. */
  branch: string
  /** The issue that branch is for, as GitLab numbers it, or '' for none. */
  issue: string
  /** True when BEST was started against an explicit database URL. */
  singleDatabase: boolean
  /** True until the first load settles, so the shell can wait. */
  loading: boolean

  /**
   * Whether a screen holds edits that a swap would discard.
   *
   * Nothing sets this today - every field saves as it is changed, so there is
   * no draft to lose. It exists because the confirmation belongs to the picker
   * rather than to whichever screen grew the first unsaved form, and because a
   * branch with uncommitted work will need exactly this.
   */
  unsaved: boolean
  setUnsaved: (value: boolean) => void

  choose: (slug: string) => Promise<void>
  create: (body: { slug: string; name?: string; description?: string }) => Promise<ProjectRow>
  reload: () => Promise<void>
}

export const ProjectContext = createContext<ProjectState | null>(null)
